<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{span:24}" :lg="{span:8}">
      <a-card>
        <div slot="title">
          <a-icon type="file-search" />Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    @change="umpdSearch"
                    :format="dateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select
                    placeholder="Ex: Value's < 50 Million Rupiah"
                    v-model="kategori"
                    @change="umpdSearch"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="less">Value's &#60; 50 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 50 Million Rupiah</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="umpdSearch"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred">Transferred</a-select-option>
                    <a-select-option value="closed">Closed</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{span:24}" :lg="{span:16}">
      <DataList
        :loading="loading"
        title="UM PD List"
        createLink="umpdCreate"
        manifestLink="umpd_manifest"
        editLink="umpd_edit"
        :dataList="dataListOutput"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "umpd",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      umList: [],
      basedList: [],
      search: "",
      tempList: "",
      kategori: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },

  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    umpdSearch: function () {
      var self = this;
      let filteredDataBySearch = [];
      this.umList = this.basedList;

      if (this.search) {
        this.umList = this.umList.filter(
          (obj) =>
            (obj.no_um &&
              obj.no_um.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
            (obj.deskripsi &&
              obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
            (obj.tgl_buat &&
              this.moment(obj.tgl_buat)
                .format(this.getDefaultDateFormat)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.value_um &&
              this.formatCurrency(obj.currency, obj.value_um)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.realisasi &&
              this.formatCurrency(obj.currency, obj.realisasi)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      if (this.kategori) {
        let dataFilterKategori;

        dataFilterKategori = this.umList.filter((item) => {
          return this.kategori=="less" ? item.realisasirp<50000000 : item.realisasirp>=50000000;
        });

        this.umList = dataFilterKategori;
      }

      if (this.status) {
        this.umList = this.umList.filter(
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(this.status) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format("YYYY-MM-DD");
        let endDt = moment(self.transactionDt[1]).format("YYYY-MM-DD");
        this.umList = this.umList.filter(
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      if (
        !this.kategori &&
        !this.search &&
        !this.status &&
        !this.transactionDt
      ) {
        this.umList = this.basedList;
      }
    },
    dataListOutput() {
      let output = [];

      this.umList.forEach((data) => {
        const date = moment(data.tgl_buat).format(this.getDefaultDateFormat);
        output.push({
          title: data.no_um,
          subdesc: [
            [
              {
                label: date,
                value: "",
              },
            ],
            [
              {
                label: data.deskripsi,
                value: "",
              },
            ],
            [
              {
                label: "Estimated value",
                value: this.formatCurrency(data.currency, data.value_um),
              },
            ],
            [
              {
                label: "Realization value",
                value:
                  data.lk_realisasi == "0"
                    ? "There are no reports yet"
                    : this.formatCurrency(data.currency, data.realisasi),
              },
            ],
          ],
          timeline: JSON.parse(data.status_app),
          unread: data.unread == "1" ? true : false,
          status: data.status,
          id: data.id_um,
          canceled_Status: (data.dana_sts == 1 ? "Canceled" : ""),
          cancelStatus: data.cancel_sts
            ? data.cancel_sts == 1
              ? "Canceled"
              : null
            : null,
        });
      });

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "um_pd",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.umList = response.data.data;
          this.basedList = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      console.log(item);
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "umpd",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>